import { render, staticRenderFns } from "./news.vue?vue&type=template&id=09f6f89d&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=09f6f89d&prod&lang=css&"
import style1 from "./news.vue?vue&type=style&index=1&id=09f6f89d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6f89d",
  null
  
)

export default component.exports